import { useState, useEffect } from 'react';
import CheckoutPage from './pages/checkout';
import SuccessPage from './pages/success';
import ErrorPage from './pages/error';
import CardRegisterCallbackPage from './pages/card-register-callback';
import Layout from './components/Layout';
import { useThemeStore } from './stores/themeStore';

type PageType = 'checkout' | 'success' | 'error' | 'card-register-callback';

function App() {
  const [currentPage, setCurrentPage] = useState<PageType>('checkout');
  const { setTheme } = useThemeStore();

  // Initialize theme from localStorage
  useEffect(() => {
    const isDark = localStorage.getItem('theme-store')
      ? JSON.parse(localStorage.getItem('theme-store') || '{}').state?.isDark ?? false
      : false;
    setTheme(isDark);
  }, [setTheme]);

  // Simple routing based on URL path
  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('/card-register-callback')) {
      setCurrentPage('card-register-callback');
    } else if (path.includes('/success')) {
      setCurrentPage('success');
    } else if (path.includes('/error')) {
      setCurrentPage('error');
    } else {
      setCurrentPage('checkout');
    }
  }, []);

  return (
    <Layout>
      {currentPage === 'checkout' && <CheckoutPage />}
      {currentPage === 'success' && <SuccessPage />}
      {currentPage === 'error' && <ErrorPage />}
      {currentPage === 'card-register-callback' && <CardRegisterCallbackPage />}
    </Layout>
  );
}

export default App;
